/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import FormFader from "../Fader/FormFader";
import { Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router";
import { getCaseLink } from "@/src/services/productService";
import type { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type RecordingConsentSuccessProps = {
  product?: AbstractCase;
};

export default function RecordingConsentSuccess({ product }: RecordingConsentSuccessProps) {
  return (
    <FormFader>
      <ProductBox headline={"Vielen Dank für Ihre Auswahl"}>
        <Typography variant={"body2"}>Sie können Ihre Entscheidung jederzeit in Ihrer Servicewelt ändern.</Typography>
        <Grid container sx={{ marginTop: "1.5rem" }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Button fullWidth size={"small"} variant={"contained"} component={Link} to={product ? getCaseLink(product) : "/servicewelt"}>
              Zurück zur Servicewelt
            </Button>
          </Grid>
        </Grid>
      </ProductBox>
    </FormFader>
  );
}
